import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_PAYMENTS_LIST, GET_PAYMENTS_LIST_SUCCESS, GET_PAYMENTS_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getPaymentsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/projects`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PAYMENTS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PAYMENTS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PAYMENTS_LIST_ERROR, payload: error });
  }
}

export function* watchGetPaymensList() {
  yield takeEvery(GET_PAYMENTS_LIST, getPaymentsList);
}

function* getPaymentsListSaga() {
  yield all([fork(watchGetPaymensList)]);
}

export default getPaymentsListSaga;
